import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal,NgbActiveModal, NgbModalOptions, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import {
  UntypedFormGroup,
  FormControl,
  UntypedFormBuilder,
  Validators,
} from "@angular/forms";
import { CustomValidators } from "src/app/core/custom-validator/custom-validators";
import { emailRegex } from 'src/app/core/model/regex';
import { apiLinks } from 'src/app/core/api-links/api-links';
import { CommonService } from "src/app/providers/common.service";
@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {
  @Input() header: any;
  @Input() body: any;
  @Input() confirmMsg: any;
  @Input() amount: any;
  @Input() tipFlag: boolean;
  @Input() isInput: boolean;
  @Input() inputLabel: string;
  @Input() jobId: string;
  @Input() confirmButtonLabel: string = 'Confirm';
  @Input() cancelButtonLabel: string = 'Cancel';
  @Input() informationModal: boolean;
  @Input() confirmationSpinner: boolean = false;
  @Input() hasAlternatePayment: boolean = false;
  @Input() isAuthGeneration: boolean = false;
  @Input() authGenreationInput: any;
  @Output() emitData = new EventEmitter();
  enableConfirmSpinner = false;
  emailForm: UntypedFormGroup;
  errorMsg = "";

  constructor(public modal: NgbActiveModal, private ngbModal:NgbModal, private formBuilder: UntypedFormBuilder,
    public commonService: CommonService) { }

  ngOnInit(): void {
    this.emailForm = this.createEmailForm();
  }

  createEmailForm(): UntypedFormGroup {
    return this.formBuilder.group({
      email: [
        "",
        [
          Validators.required,
          CustomValidators.PatternValidator(emailRegex, { hasEmail: true }),
        ],
      ]
    });
  }

  closeModal() {
    this.enableConfirmSpinner = this.confirmationSpinner;
    if(!this.confirmationSpinner) {
      this.modal.close('confirm');
    } else {
      this.emitData.next('processing');
    }
  }

  saveEmail(){
    let email = this.emailForm.get('email').value;
    this.enableConfirmSpinner = true;
    this.errorMsg;
    let result =  this.commonService.getCommonHttpClientQueryParams(apiLinks.saveEmailForReportDownload,{jobId:this.jobId,email}).subscribe((res)=>{
      this.modal.close('confirm');
      this.enableConfirmSpinner = false;
     
    },(err)=>{
      this.errorMsg = "An error occurred while saving the email.";
      this.enableConfirmSpinner = false;
    });
    //
  }

  cancelModal(event){
    event.preventDefault();
    console.log("---->cancel button calling..");
    this.modal.close('cancel')
  }
}
